import React, { PropsWithChildren, useState } from "react";

import { FlatList, View, useWindowDimensions } from "react-native";
import { SegmentedButtons, Text } from "react-native-paper";
import { useTailwind } from "tailwind-rn";

import Divider from "./divider";

type Props<T> = PanesProps & {
  items: T[];
  renderItem: (item: T, index: number) => JSX.Element;
  expectedCount?: number;
  errorCount?: number;
};

// TODO: this should really be called `PanesList`
export default function PanesContainer<T>({
  items,
  expectedCount,
  errorCount,
  numColumns = 3,
  renderItem,
}: Props<T>) {
  const tailwind = useTailwind();
  return (
    <View style={tailwind("m-4")}>
      <View style={tailwind("flex-row gap-4")}>
        <Text variant="headlineLarge">Rendered: {items.length}</Text>
        {expectedCount && (
          <Text variant="headlineLarge">Expected: {expectedCount}</Text>
        )}
        {errorCount && (
          <Text variant="headlineLarge">Expected: {errorCount}</Text>
        )}
      </View>

      <Divider />

      {items.map((item, index) => {
        const parent = renderItem(item, index);
        // if the parent is a fragment, extract children, if not treat as single child
        const children =
          parent.type === React.Fragment ? parent.props.children : parent;
        return (
          <View key={index}>
            <Panes numColumns={numColumns}>{children}</Panes>
            <Divider />
          </View>
        );
      })}
    </View>
  );
}

type PanesProps = PropsWithChildren<
  Partial<{
    numColumns: number;
    showBorder: boolean;
  }>
>;
// TODO: rename this to PanesContainer
export function Panes({
  children,
  numColumns = 3,
  showBorder = false,
}: PanesProps) {
  const tailwind = useTailwind();

  const { width } = useWindowDimensions();

  const cols = width < 400 ? 1 : width < 800 ? 2 : numColumns;

  console.log({ width });

  return (
    <FlatList
      key={cols}
      numColumns={cols}
      data={React.Children.toArray(children)}
      renderItem={({ item, index }) => (
        <View
          style={tailwind(`flex-1 ${showBorder ? "border" : ""}`)}
          key={index}
        >
          {item}
        </View>
      )}
    />
  );
}

const buttons = ["1", "2", "3", "4", "5", "6"].map((n) => ({
  value: n,
  label: n,
}));
export function PanesWithControls({
  children,
  showBorder,
  numColumns = 3,
}: PanesProps) {
  const [c, setC] = useState(numColumns.toString());
  const tailwind = useTailwind();
  return (
    <>
      <View style={tailwind("self-center m-4 gap-2")}>
        <Text style={tailwind("text-center")}>column controls</Text>
        <SegmentedButtons value={c} onValueChange={setC} buttons={buttons} />
      </View>
      <Panes numColumns={Number(c)} showBorder={showBorder}>
        {children}
      </Panes>
    </>
  );
}
